import React from 'react'
import './index.scss'

interface FooterProps {
    row?: React.ReactNode[]
}

const TableFooter = ({ row }: FooterProps) => (
    <div className="table-footer">
        {row && (
            <div className="table-row">
                {row?.map((cell, index) => (
                    <div className="table-cell" key={index}>
                        {cell}
                    </div>
                ))}
            </div>
        )}
    </div>
)

export default TableFooter
